import { toString } from '@/utils/date';

export default class {
  parent = null;

  name = '';

  preview = '';

  date = {
    from: null,
    to: null,
  };

  type = null;

  city = null;

  country = null;

  tourist = {
    adult: 1,
    child: 0,
  };

  description = '';

  services = [];

  constructor(parent) {
    this.parent = parent;
  }

  set(data) {
    this.name = data.name || '';
    this.date.from = data.beginDateTime.value;
    if (this.date.from) {
      this.date.to = new Date(this.date.from);
      this.date.to.setDate(this.date.to.getDate() + (data.duration - 1 || 0));
    }
    this.type = data.tourType;
    this.city = data.city;
    this.country = data.country;
    this.description = data.shortDescription;
    this.preview = data.imagesInfo.previewImageUrl;
    this.tourist.adult = data.adults;
    this.tourist.child = data.children;
    this.services = data.tourServices.map(i => i.name);
  }

  get labelTourist() {
    if (this.tourist.adult) {
      return `Взрослых: ${this.tourist.adult}${this.tourist.child ? `, детей: ${this.tourist.child}` : ''}`;
    }
    return `Детей: ${this.tourist.child}`;
  }

  get labelDate() {
    const { from, to } = this.date;
    if (!from || !to) {
      return '';
    }
    if (from.getTime() === to.getTime()) {
      return toString(from);
    }
    return `${toString(from)} - ${toString(to)}`;
  }
}
